module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/portali-immobiliari.7d1fa17343b0777636020b60a1867027.png";